module.exports = __webpack_public_path__ + "img/van.2d783682.webp";